import { DrawFields } from './DrawFields';
import { useEffect, useState } from 'react';
import { Container, Divider, Flex, Text } from '@mantine/core';
import { useIntl } from 'react-intl';
import { AddField } from './AddField';

const alreadyExists = (fields: any[], field: any) => {
  return fields.some((f) => f.name === field.name);
};

export const FormBuilder = ({
  fields,
  onFieldsChange,
}: {
  fields: any[];
  onFieldsChange: (fields: any[]) => void;
}) => {
  const intl = useIntl();

  const [localFields, setLocalFields] = useState<any[]>(fields);
  const [editField, setEditField] = useState<any>(null);
  const [updatedField, setUpdatedField] = useState<any>(null);

  // Sync localFields when fields prop changes
  useEffect(() => {
    setLocalFields(fields);
  }, [fields]);

  useEffect(() => {
    onFieldsChange(localFields);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localFields]);

  return (
    <Flex gap="md" direction="column">
      <Text size="sm" fw={500}>
        {intl.formatMessage({ id: 'fields' })}{' '}
        <Text component="span" c="red">
          *
        </Text>
      </Text>

      {localFields.length > 0 && (
        <DrawFields
          fields={localFields}
          onFieldDelete={(field: any) => {
            setLocalFields([
              ...localFields.filter((f) => f.name !== field.name),
            ]);
          }}
          onFieldEdit={(field: any) => {
            setEditField(field);
            setUpdatedField(field);
          }}
          onFieldsUpdate={(fields: any[]) => {
            setLocalFields(fields);
          }}
        />
      )}

      {localFields.length === 0 && (
        <Divider
          size="xs"
          variant="dashed"
          label={intl.formatMessage({ id: 'noFieldsAvailable' })}
          labelPosition="center"
        />
      )}

      {localFields.length > 0 && <Divider size="xs" variant="dashed" />}

      <Container>
        <AddField
          editField={updatedField}
          onEditCancel={() => {
            setEditField(null);
            setUpdatedField(null);
          }}
          onFieldUpdate={(field: any) => {
            setLocalFields([
              ...localFields.map((f) =>
                f.name === editField.name ? field : f
              ),
            ]);
            setEditField(null);
            setUpdatedField(null);
          }}
          onFieldAlreadyExists={(field: any) => {
            return alreadyExists(localFields, field);
          }}
          onAddField={(field: any) => {
            setLocalFields([...localFields, field]);
          }}
        />
      </Container>
    </Flex>
  );
};
